// Utility to get CSRF token from cookie
export function getCsrfTokenFromCookie(): string {
  const match = document.cookie.match(new RegExp('(^| )csrfToken=([^;]+)'));
  return match ? match[2] : '';
}
